import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { CanvasService } from '../../services';
import { BaseComponent } from '../../shared';


/**
 * Component for editing (rotate).
 */
@Component({
	selector: 'image-edit',
	templateUrl: './image-edit.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class ImageEditComponent extends BaseComponent {

	private readonly canvasSrv = inject(CanvasService);

	isResetAnalysisWarning = input(false);
	changed = output<void>();

	isImgVisible = false;

	/**
	* Confirm tool edit.
	*/
	confirm(): void {
		this.canvasSrv.dispatch('confirmRotate');
		this.changed.emit();
	}

}
